// @flow
export const TRIPS_LOADING = "TRIPS_LOADING"
export const TRIPS_LOADING_REQUEST = "TRIPS_LOADING_REQUEST"
export const TRIPS_LOADING_SUCCESS = "TRIPS_LOADING_SUCCESS"
export const TRIPS_LOADING_FAILURE = "TRIPS_LOADING_FAILURE"

export function loadTrips(promise: Promise<*>) {
  return {
    type: TRIPS_LOADING,
    promise,
  }
}
